import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import "./sidePanel.css";
import { ActivePanelType } from "../../types";
import { PropertyBoundaryPanelProps } from "./PropertyBoundaryPanel";
import { ObjectsPanelProps } from "./ObjectsPanel";
import { ObjectsPanel } from "./ObjectsPanel";
import { PropertyBoundaryPanel } from "./PropertyBoundaryPanel";

interface SidePanelProps {
  activePanel: ActivePanelType;
  updateActivePanel: (activePanel: ActivePanelType) => void;
  propertyBoundaryPanelProps: PropertyBoundaryPanelProps;
  objectsPanelProps: ObjectsPanelProps;
  companyInfo: { name: string; company_id: string } | null;
}

export const SidePanel: FC<SidePanelProps> = ({
  activePanel,
  updateActivePanel,
  propertyBoundaryPanelProps,
  objectsPanelProps,
  companyInfo,
}) => {
  const { t } = useTranslation();
  const [showBoundaryWarning, setShowBoundaryWarning] = useState(false);
  const { isBoundaryMode, onBoundaryModeToggle } = propertyBoundaryPanelProps;

  const handleObjectsPanelClick = () => {
    if (isBoundaryMode) {
      setShowBoundaryWarning(true);
    } else {
      updateActivePanel("object");
    }
  };

  const handleConfirmSwitchToObjects = () => {
    setShowBoundaryWarning(false);
    onBoundaryModeToggle("cancel");
    updateActivePanel("object");
  };

  const handleCancelSwitchToObjects = () => {
    setShowBoundaryWarning(false);
  };

  return (
    <div className="side-panel">
      {/* Company Header */}
      {companyInfo && (
        <div className="company-header">
          <div className="company-name">
            <span className="company-label">Company:</span>
            <span className="company-value">{companyInfo.name}</span>
          </div>
        </div>
      )}

      {/* Top Bar with Panel Selection Buttons */}
      <div className="panel-selector">
        <button
          className={`panel-button ${activePanel === "object" ? "active" : ""}`}
          onClick={handleObjectsPanelClick}
        >
          {t("admin.objects")}
        </button>
        <button
          className={`panel-button ${
            activePanel === "boundary" ? "active" : ""
          }`}
          onClick={() => updateActivePanel("boundary")}
        >
          {t("admin.boundaries")}
        </button>
      </div>

      {/* Conditional Panel Rendering */}
      {activePanel === "object" ? (
        <ObjectsPanel {...objectsPanelProps} />
      ) : (
        <PropertyBoundaryPanel {...propertyBoundaryPanelProps} />
      )}

      {/* Boundary Mode Warning Modal */}
      {showBoundaryWarning && (
        <div className="boundary-warning-overlay">
          <div className="boundary-warning-modal">
            <div className="warning-header">
              <div className="warning-icon">⚠️</div>
              <h3>{t("admin.boundaryModeActive")}</h3>
            </div>
            <div className="warning-content">
              <p>
                {t("admin.boundaryModeSwitchWarning")}
                <br />
                <p>{t("admin.areYouSureContinue")}</p>
              </p>
            </div>
            <div className="side-panel-unsaved-warning-actions">
              <button
                className="warning-cancel-btn"
                onClick={handleCancelSwitchToObjects}
              >
                {t("common.cancel")}
              </button>
              <button
                className="warning-confirm-btn"
                onClick={handleConfirmSwitchToObjects}
              >
                {t("admin.switchToObjects")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
